(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/live-match-tracker/views/live-match-tracker.js') >= 0) return;  svs.modules.push('/components/sport/live-match-tracker/views/live-match-tracker.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.live_match_tracker=_svs.sport.live_match_tracker||{};
_svs.sport.live_match_tracker.templates=_svs.sport.live_match_tracker.templates||{};
svs.sport.live_match_tracker.templates.live_match_tracker = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"extend")||(depth0 && lookupProperty(depth0,"extend"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"scripts",{"name":"extend","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":5,"column":15}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        \u003Cscript defer type=\"text/javascript\" src=\"https://widgets.sir.sportradar.com/"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"licenseID") || (depth0 != null ? lookupProperty(depth0,"licenseID") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"licenseID","hash":{},"data":data,"loc":{"start":{"line":4,"column":85},"end":{"line":4,"column":98}}}) : helper)))
    + "/widgetloader\" data-sr-language=\"se\">\u003C/script>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = "";

  stack1 = ((helper = (helper = lookupProperty(helpers,"isSelfService") || (depth0 != null ? lookupProperty(depth0,"isSelfService") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"isSelfService","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":6,"column":18}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"isSelfService")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});
Handlebars.partials['components-sport-live_match_tracker-live_match_tracker'] = svs.sport.live_match_tracker.templates.live_match_tracker;
})(svs, Handlebars);


 })(window);